import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Magacin } from './magacin';

@Component({
  selector: 'app-magacin',
  templateUrl: './magacin.component.html'
})
export class MagacinComponent extends BaseModalContainer<Magacin> implements OnInit {
  constructor(
    protected modalContainerService: ModalContainerService<Magacin>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
